import { US } from '../../constants/country-codes';

const byShipStation = 'by ShipStation';
const oneBalance = /One Balance[™]*/;
const shipstationCarrierServices = /- ShipStation Carrier Services/;
const brandingWhiteOuts = [byShipStation, oneBalance, shipstationCarrierServices];

export const rebrandCarrierProviderNames = (providerList, sellerHomeCountry) => {
  if (sellerHomeCountry !== US) {
    return providerList;
  }
  const brandingToRemove = oneBalance;
  const brandingToAdd = byShipStation;
  return providerList.map((provider) => ({
    ...provider,
    name: provider?.name?.replace(brandingToRemove, brandingToAdd)?.trim() ?? '',
  }));
};

export const getSanitizedName = (name) => {
  return brandingWhiteOuts.reduce((providerName, whiteOut) => {
    return providerName.replace(whiteOut, '').trim();
  }, name);
};
